export const TWO_FACTOR_TYPE = {
    EMAIL: 'E',
    CELLPHONE: 'H',
    EMAIL_OR_CELLPHONE: 'S',
}